import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { CollapseList, RuleContent, StatusIcon, TaskListItem, useAutoExpandFailedRules } from '@wix/rules-panel-ui';
import React, { useMemo, useState } from 'react';
import { useGetRuleIdToLabelMap } from '../../../../../hooks/use-get-ruleId-to-label-map';
import { useIsEditor3 } from '../../../../../hooks/use-is-editor3';
import { useGetPageRuleIds } from '../utils/use-get-page-rule-ids';
import { CollapseActionsProvider, ItemScopeProvider } from './context/collapse-actions-context';
export const SpecificPageTaskList = /*#__PURE__*/React.memo(_ref => {
  let {
    pageId,
    ruleResults,
    topComponent
  } = _ref;
  const {
    t
  } = useTranslation();
  const [openItems, setOpenItems] = useState(new Set());
  const ruleIds = ruleResults.map(result => result.ruleId);
  const ruleIdsForSkeleton = useGetPageRuleIds(pageId, ruleIds);
  const {
    pageLevelruleIdToLabelKeyMap
  } = useGetRuleIdToLabelMap();
  const isEditor3 = useIsEditor3();
  const tasks = useMemo(() => {
    if (!ruleResults || ruleResults.length === 0) {
      return ruleIdsForSkeleton == null ? void 0 : ruleIdsForSkeleton.map(ruleId => {
        return /*#__PURE__*/React.createElement(ItemScopeProvider, {
          id: ruleId,
          key: ruleId
        }, /*#__PURE__*/React.createElement(TaskListItem, {
          id: ruleId,
          isLoading: true,
          showBottomShadow: !isEditor3,
          showTopShadow: !isEditor3,
          title: t(pageLevelruleIdToLabelKeyMap[ruleId]),
          variant: "collapsible"
        }));
      });
    }
    return ruleResults.map((ruleResult, index, array) => {
      const isLast = index === array.length - 1;
      return /*#__PURE__*/React.createElement(ItemScopeProvider, {
        id: ruleResult.ruleId,
        key: ruleResult.ruleId
      }, /*#__PURE__*/React.createElement(TaskListItem, {
        id: ruleResult.ruleId,
        prefix: /*#__PURE__*/React.createElement(StatusIcon, {
          status: ruleResult.status
        }),
        showBottomShadow: !isLast && !isEditor3,
        showTopShadow: !isEditor3,
        title: ruleResult.label,
        variant: "collapsible"
      }, /*#__PURE__*/React.createElement(Box, {
        dataHook: "specific-page-task-list-item-content",
        padding: "SP3 SP6 SP8 SP6"
      }, /*#__PURE__*/React.createElement(RuleContent, {
        ruleResult: ruleResult
      }))));
    });
  }, [ruleResults, ruleIdsForSkeleton, t, pageLevelruleIdToLabelKeyMap, isEditor3]);
  const ruleResultsForAutoExpand = useMemo(() => {
    return ruleResults.map(result => {
      return {
        id: result.ruleId,
        status: result.status
      };
    });
  }, [ruleResults]);
  useAutoExpandFailedRules({
    items: ruleResultsForAutoExpand,
    setOpenItems
  });
  return /*#__PURE__*/React.createElement(CollapseActionsProvider, {
    setOpenItems: setOpenItems
  }, /*#__PURE__*/React.createElement(CollapseList, {
    contentGap: 0,
    openItems: openItems,
    setOpenItems: setOpenItems
  }, topComponent, tasks));
});
//# sourceMappingURL=specific-page-task-list.js.map